const blocks = [
  {
    letter: "A",
    title: "Accountable",
    body: "Every site is led by a foreman who signs off on quality. A name and a face — not an anonymous contractor.",
  },
  {
    letter: "G",
    title: "Guaranteed",
    body: "Same-day response on issues, transparent reporting, and a personal callback from the founders if anything falls short.",
  },
  {
    letter: "S",
    title: "Sustainable",
    body: "100% eco-certified chemicals, microfibre systems, and a Green Pledge that respects your facility and the planet.",
  },
];

export default function AGSMeaning() {
  return (
    <section
      id="meaning"
      data-testid="ags-meaning-section"
      className="bg-[#050B14] text-white py-28 md:py-40 border-t border-[#0E2A57] relative"
    >
      {/* Editorial grid overlay — institutional, not blurry orbs */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(190,231,245,0.6) 1px, transparent 1px), linear-gradient(to bottom, rgba(190,231,245,0.6) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />

      <div className="relative container-ags">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-16 bg-[#2BB6E5]" />
            <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#BEE7F5] font-medium">
              02 — The Meaning Behind Our Brand
            </span>
          </div>
          <h2 className="font-heading font-extrabold text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.035em] text-white">
            <span className="italic-display font-normal text-[#BEE7F5]">AGS</span>{" "}
            — three letters,<br className="hidden md:block" /> three promises from one family.
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/15 border border-white/15">
          {blocks.map((b, i) => (
            <article
              key={b.letter}
              data-testid={`ags-block-${b.letter}`}
              className="bg-[#050B14] p-8 md:p-10 transition-colors duration-500 hover:bg-[#0E2A57] group flex flex-col gap-6"
            >
              <div className="flex items-start justify-between">
                <span className="italic-display text-[#BEE7F5] group-hover:text-[#2BB6E5] text-7xl md:text-8xl leading-none font-normal transition-colors duration-500">
                  {b.letter}
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#2BB6E5] mt-3">
                  0{i + 1} / 03
                </span>
              </div>
              <div>
                <h3 className="font-heading font-bold text-base md:text-lg text-white tracking-[-0.02em]">
                  {b.title}
                </h3>
                <p className="mt-3 text-white/70 text-sm md:text-[15px] leading-[1.6]">
                  {b.body}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
